<div class="dataPickerDs__cont">
  <div #pickerGroupLayer *ngFor="let group of data; let gIndex = index; trackBy : trackByGroup" class="dataPickerDs__picker-group">
    <div class="dataPickerDs__picker-list">
      <div *ngFor="let item of group.List; let iIndex = index; trackBy : trackByItem" class="dataPickerDs__picker-item" [class.selected]="isCurrentItem(gIndex, iIndex)" [ngStyle]="getItemStyle(gIndex, iIndex)">
        <div class="dataPickerDs__picker-item-value dataPickerDs__picker-item-value--{{getGroupAlign(group)}}">
          <ng-container *ngTemplateOutlet="imageOrIcon; context: { item: item }"></ng-container>
          <app-ds-typography
            [size]="fontSize"
            [fontFamily]="fontFamily"
            [color]="typographyColor"
            [ellipsis]="true"
            [text]="item.Value">
          </app-ds-typography>
        </div>
      </div>
    </div>
  </div>
  <div #pickerHandleLayer class="dataPickerDs__picker-handle-layer">
    <div data-type="top" class="dataPickerDs__layer-top"></div>
    <div data-type="middle" class="dataPickerDs__layer-middle"></div>
    <div data-type="bottom" class="dataPickerDs__layer-bottom"></div>
  </div>
</div>

<ng-template #imageOrIcon let-item="item">
  <ng-container *ngTemplateOutlet="item?.Icon ? iconTemplate : imgTemplate; context: { item: item }"></ng-container>
</ng-template>

<ng-template #imgTemplate let-item="item">
  <ng-container *ngIf="item?.Image">
    <div class="dataPickerDs__value-image">
      <app-ds-image
        [size]="imageSize"
        [src]="item?.Image"
        [objectFit]="'contain'"
        [alt]="item?.Image">
      </app-ds-image>
    </div>
  </ng-container>
</ng-template>

<ng-template #iconTemplate let-item="item">
  <div class="dataPickerDs__value-icon">
    <app-ds-icon
      [icon]="item?.Icon"
      [size]="22"
      [color]="iconFillColor">
    </app-ds-icon>
  </div>
</ng-template>
